import React, {useEffect, useState} from 'react'
import {useStore} from 'react-hookstore'
import {textStrings} from './textStrings'

export default function Header() {
  const [lang] = useStore('language')
  const dirs = ['EN','ES']
  const [title, setTitle] = useState(textStrings['title'][lang])
  const [subTitle, setSubTitle] = useState(textStrings['subtitle'][lang])
  useEffect(() => setTitle(textStrings['title'][lang]),[lang])
  useEffect(() => setSubTitle(textStrings['subtitle'][lang]),[lang])
  const divStyle = {
    textAlign: 'center'
  }
  const [welcome, setWelcome] = useState('')

  return(
    <header className='App-header'>
      <h1 className="App-title">{title}</h1>
      <h2 className="App-subtitle">{subTitle}</h2>
      <div style={divStyle} className='App-intro'>
        {
          useEffect(() =>  {
            function fetchData() {
              fetch(`./${dirs[lang]}/welcome.html`)
                .then(resp => resp.text())
                .then(text => {
                  setWelcome(<div dangerouslySetInnerHTML={{__html: text}}/>)
                })
            }
            fetchData()
          },[lang]
          )
        }
        {welcome}
      </div>
    </header>
  )
}
